import { Component, OnInit, Input } from '@angular/core';
import { cloneDeep } from 'lodash';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { GlobalSelectionControlService } from 'src/app/map/services/global-selection-control.service';
import { ProcedureModel } from 'src/app/models/procedure';
import { ProcedureLegModel } from 'src/app/models/procedure-leg';
import { NavaidsService } from 'src/app/services/navaids.service';
import { PointsService } from 'src/app/services/points.service';
import { ProcedureAssessmentsService } from 'src/app/services/procedure-assessments.service';
import { ProcedureControlService } from 'src/app/services/procedure-control.service';
import { TabsService } from 'src/app/services/tabsService';
import { ToolsControlService } from 'src/app/services/tools-control.service';

@Component({
  selector: 'app-save-procedure-assessment',
  templateUrl: './save-procedure-assessment.component.html',
  styleUrls: ['../../app.component.scss'],
  standalone: false
})
export class SaveProcedureAssessmentComponent implements OnInit {

  @Input() isFirstWindow = true;
  newProcedure: boolean = true;
  newPoints: boolean = true;
  newProcedureId: string = "";
  newProcedureName: string = "";

  arrayPoints = [];


  constructor(public procedureController : ProcedureControlService,
    private navaidController : NavaidsService,
    private bsModalRef : BsModalRef,
    private popupService : BsModalService,
    public procedureAssessmentsController : ProcedureAssessmentsService,
    public toolsService : ToolsControlService,
    public tabsService: TabsService,
    public pointsService : PointsService,
    private globalSelectionService : GlobalSelectionControlService) { }

  ngOnInit(): void {
    this.procedureAssessmentsController.selectedProcedure.procedureCoordinatePoints.forEach(element => {

      const indexOnLegs =  this.procedureAssessmentsController.selectedProcedure.procedureLegs.findIndex(leg => leg.startPoint.id == element.id || leg.endPoint.id == element.id);
      const hasOffest = this.procedureAssessmentsController.selectedProcedure.procedureLegs[indexOnLegs].offset != 0
                        && this.procedureAssessmentsController.selectedProcedure.procedureLegs[indexOnLegs].offset != null
                        && this.procedureAssessmentsController.selectedProcedure.procedureLegs[indexOnLegs].direction != "NotSet"
                        && this.procedureAssessmentsController.selectedProcedure.procedureLegs[indexOnLegs].direction != null;

      const newPoint = {
        sequencenumber: element.sequencenumber,
        hasOffest,
        uniqueId: element.coordPoint.id,
        currentId: element.coordPoint.coordpointid,
        currentName: element.coordPoint.name,
        newId: element.coordPoint.coordpointid,
        newName : element.coordPoint.name,
      }

      this.arrayPoints.push(newPoint);
    });
    this.definePointsChanged();
  }

  definePointsChanged() {
    const pointsChanged = [];
    this.procedureAssessmentsController.selectedProcedure.procedureCoordinatePoints.forEach(point => {
      const interfacePoint = this.procedureAssessmentsController.procedureInterfaceToHTML.procedureCoordinatePoints.find(pointInterface =>
        pointInterface.coordPoint.id == point.coordPoint.id);
      if (interfacePoint.coordPoint.ismodified){
        pointsChanged.push(point.coordPoint.id);
        const toSavePoint = this.arrayPoints.find(arrayPoint => arrayPoint.uniqueId == point.coordPoint.id);
        toSavePoint.newId = "";
        toSavePoint.newName = "";
      }
    })
    this.procedureAssessmentsController.selectedProcedure.procedureLegs.forEach(leg => {
      if (leg.direction != "NotSet" && leg.offset != 0.0){
        if (!pointsChanged.includes(leg.startPoint.coordPoint.id)){
          pointsChanged.push(leg.startPoint.coordPoint.id);
          const toSavePoint = this.arrayPoints.find(arrayPoint => arrayPoint.uniqueId == leg.startPoint.coordPoint.id);
          toSavePoint.newId = "";
          toSavePoint.newName = "";
        }
        if (!pointsChanged.includes(leg.endPoint.coordPoint.coordpointid)){
          pointsChanged.push(leg.endPoint.coordPoint.coordpointid);
          const toSavePoint = this.arrayPoints.find(arrayPoint => arrayPoint.uniqueId == leg.endPoint.coordPoint.id);
          toSavePoint.newId = "";
          toSavePoint.newName = "";
        }
      }
    })
  }

  toggleNewProcedure(event): void {
    this.newProcedure = event.target.value == "newProc";
  }

  toggleNewPoints(event): void {
    this.newPoints = event.target.value == "newPoints";
    let title = document.getElementById("title2ndWindow");
    if (this.newPoints){
      this.definePointsChanged();
      title.innerHTML = "If new points are added to the procedure, please insert an ID and Name for each one. " +
                        "Otherwise, the existing points will be used in the new procedure.";
    } else {
      this.arrayPoints.forEach( newPoint =>{
        newPoint.newId = newPoint.currentId;
        newPoint.newName = newPoint.currentName;
      })
      title.innerHTML = "All points will be copied to the new procedure. If the point was moved and used by other(s) procedure(s)," +
                        "the move will be also reflected in the other procedure(s).";
    }
  }

  cancel(): void {
    this.bsModalRef.hide();
  }

  async saveMovePoints(): Promise<void> {

    let procedureToSave = this.procedureAssessmentsController.selectedProcedure;

    procedureToSave.proceduretype = procedureToSave.procedureid.substring(0, procedureToSave.procedureid.indexOf('_'));


    procedureToSave.procedureid = procedureToSave.procedureid.substring(procedureToSave.procedureid.indexOf('|')+1) ;

    let offsetLegsPromise = new Promise<ProcedureLegModel[]>( async function(resolve, reject) {
      let offsetLegs: ProcedureLegModel [] = [];

      for (let index = 0; index < procedureToSave.procedureLegs.length; index++) {

        const legToOffSet = procedureToSave.procedureLegs[index];

        if (legToOffSet.offset != 0.0 && legToOffSet.direction != "NotSet") {
          //get angle
          const azimuthAngle = await this.procedureAssessmentsController.getAzimuthAngle(legToOffSet.startPoint.coordPoint, legToOffSet.endPoint.coordPoint);

          //get offset for starpoint
          const startCPoffset = await this.procedureAssessmentsController.getCoordinateOffset(legToOffSet.startPoint.coordPoint, legToOffSet.offset, azimuthAngle, legToOffSet.direction);

          //get offset for endpoint
          const endCPoffset = await this.procedureAssessmentsController.getCoordinateOffset(legToOffSet.endPoint.coordPoint, legToOffSet.offset, azimuthAngle, legToOffSet.direction);

          let procOffset = new ProcedureLegModel();
          procOffset.startPoint = cloneDeep(legToOffSet.startPoint);
          procOffset.startPoint.coordPoint = startCPoffset;
          procOffset.endPoint = cloneDeep(legToOffSet.endPoint);
          procOffset.endPoint.coordPoint = endCPoffset;
          if (offsetLegs.length > 0){
            offsetLegs[offsetLegs.length - 1].endPoint = cloneDeep(legToOffSet.startPoint);
            offsetLegs[offsetLegs.length - 1].endPoint.coordPoint = startCPoffset;
          }

          offsetLegs.push(procOffset);

        } else {
          let procOffset = new ProcedureLegModel();
          procOffset.startPoint = cloneDeep(legToOffSet.startPoint);
          procOffset.endPoint = cloneDeep(legToOffSet.endPoint);

          offsetLegs.push(procOffset);
        }
      }
      resolve(offsetLegs);
    }.bind(this));
    offsetLegsPromise.then(offsetLegs => {
      // TODO: make this code in a more efficient way
      for (let index = 0; index < procedureToSave.procedureLegs.length; index++){
        if (procedureToSave.procedureLegs[index].direction != "NotSet" && procedureToSave.procedureLegs[index].offset != 0.0
            && procedureToSave.procedureLegs[index].offset != null && procedureToSave.procedureLegs[index].direction != null){

          procedureToSave.procedureLegs[index].startPoint.coordPoint.latitude = Math.round(offsetLegs[index].startPoint.coordPoint.latitude * 100000) / 100000;
          procedureToSave.procedureLegs[index].startPoint.coordPoint.longitude = Math.round(offsetLegs[index].startPoint.coordPoint.longitude * 100000) / 100000;
          procedureToSave.procedureLegs[index].endPoint.coordPoint.latitude = Math.round(offsetLegs[index].endPoint.coordPoint.latitude * 100000) / 100000;
          procedureToSave.procedureLegs[index].endPoint.coordPoint.longitude = Math.round(offsetLegs[index].endPoint.coordPoint.longitude * 100000) / 100000;
          const pcpFromStartPoint = procedureToSave.procedureCoordinatePoints.find(pcp =>
          pcp.coordPoint.id  ==  procedureToSave.procedureLegs[index].startPoint.coordPoint.id);
          const pcpFromEndPoint = procedureToSave.procedureCoordinatePoints.find(pcp =>
          pcp.coordPoint.id  ==  procedureToSave.procedureLegs[index].endPoint.coordPoint.id);
          pcpFromStartPoint.coordPoint.latitude = Math.round(offsetLegs[index].startPoint.coordPoint.latitude * 100000) / 100000;
          pcpFromStartPoint.coordPoint.longitude = Math.round(offsetLegs[index].startPoint.coordPoint.longitude * 100000) / 100000;
          pcpFromEndPoint.coordPoint.latitude = Math.round(offsetLegs[index].endPoint.coordPoint.latitude * 100000) / 100000;
          pcpFromEndPoint.coordPoint.longitude = Math.round(offsetLegs[index].endPoint.coordPoint.longitude * 100000) / 100000;
        }
      }
      procedureToSave.procedureCoordinatePoints.forEach(pcp => {
        procedureToSave.procedureLegs.forEach(leg => {
          pcp.coordPoint.latitude = Math.round(pcp.coordPoint.latitude * 100000) / 100000;
          pcp.coordPoint.longitude = Math.round(pcp.coordPoint.longitude * 100000) / 100000;
          if (leg.startPoint.coordPoint.id === pcp.coordPoint.id) {
            leg.startPoint.coordPoint.latitude = pcp.coordPoint.latitude;
            leg.startPoint.coordPoint.longitude = pcp.coordPoint.longitude;
          }
          if (leg.endPoint.coordPoint.id === pcp.coordPoint.id) {
            leg.endPoint.coordPoint.latitude = pcp.coordPoint.latitude;
            leg.endPoint.coordPoint.longitude = pcp.coordPoint.longitude;
          }
        });
      });


      this.procedureController.saveProcedure(procedureToSave);
      this.cancel();
      this.procedureAssessmentsController.active = !this.procedureAssessmentsController.active;
      this.toolsService.navigationOnTop = false;
      this.procedureAssessmentsController.clearVariables();

    })
  }

  async save(){
    if(this.newProcedure && this.isFirstWindow){
      this.newPoints = true;
      await this.saveNewProcedure(this.procedureAssessmentsController.selectedProcedure);
      this.cancel();
    } else {
      if (this.isFirstWindow){
        const bsModalRef : BsModalRef = this.popupService.show(SaveProcedureAssessmentComponent);
        bsModalRef.content.isFirstWindow = false;
        this.cancel();
      } else {
        if (this.newPoints){
          await this.saveNewPointsProcedure(this.procedureAssessmentsController.selectedProcedure);
          this.cancel();
        } else {
          this.newProcedure = false;
          this.saveMovePoints();
        }
        this.tabsService.closeTab();
      }
    }
  }

  private async saveNewPointsProcedure(procedureToSave: ProcedureModel){
    this.procedureAssessmentsController.removeInteractions();
    this.procedureAssessmentsController.deleteProcedureAssessmentLegsOnMap(procedureToSave.id);
    this.pointsService.deleteCoordinatePointsFromMap();
    await this.pointsService.fetchAndAddCoordinatePoints();
    await this.procedureAssessmentsController.definePointsChanged(procedureToSave).then(() => {
      this.procedureAssessmentsController.addCoordinatePointFeatures(procedureToSave)
      procedureToSave.iDNotEditable = true;
      procedureToSave.latLonNotEditable = true;
      procedureToSave.proceduretype = this.procedureAssessmentsController.procedure.getProperties().proceduretype;
      procedureToSave.name = this.procedureAssessmentsController.procedure.getProperties().name;
      procedureToSave.procedureid = this.procedureAssessmentsController.procedure.getProperties().procedureid;
      procedureToSave.id = this.procedureAssessmentsController.procedure.getProperties().id;

      procedureToSave.procedureCoordinatePoints.forEach(pcp => {
        if (!pcp.coordPoint.published){
          pcp.id = undefined;
        }
      })
      this.procedureController.procedureFromAssessment = procedureToSave;
      this.globalSelectionService.clearAllSelected();
      this.tabsService.closeTab();
      const isFromProcedureAssessment: boolean = true;
      this.tabsService.openNewEditProcedureTab(isFromProcedureAssessment);
    });
  }
  private async saveNewProcedure(procedureToSave: ProcedureModel){
    this.procedureAssessmentsController.removeInteractions();
    this.procedureAssessmentsController.deleteProcedureAssessmentLegsOnMap(procedureToSave.id);
    this.pointsService.deleteCoordinatePointsFromMap();
    await this.pointsService.fetchAndAddCoordinatePoints();
    await this.procedureAssessmentsController.definePointsChanged(procedureToSave).then(() => {
      this.procedureAssessmentsController.addCoordinatePointFeatures(procedureToSave)
      procedureToSave.id = undefined;
      procedureToSave.latLonNotEditable = true;
      procedureToSave.proceduretype = this.procedureAssessmentsController.procedure.getProperties().proceduretype;
      procedureToSave.procedureid = "";
      procedureToSave.name = "";

      procedureToSave.procedureCoordinatePoints.forEach(pcp => {
        pcp.id = undefined;
      })
      for (const fixPoint of this.procedureAssessmentsController.fixPoints){
        const realLeg = procedureToSave.procedureLegs.find(leg => leg.fixPoint != null && leg.fixPoint.coordPoint.id == fixPoint.coordPoint.id);
        realLeg.fixPoint.id = undefined;
        realLeg.fixPoint.coordPoint.id = undefined;
      }
      this.procedureController.procedureFromAssessment = procedureToSave;
      this.procedureAssessmentsController.addCoordinatePointFeatures(procedureToSave);
      this.globalSelectionService.clearAllSelected();
      this.tabsService.closeTab();
      const isFromProcedureAssessment: boolean = true;
      this.tabsService.openNewEditProcedureTab(isFromProcedureAssessment);
    });
  }


}
